import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55831a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 上传文件 ")
const _hoisted_2 = {
  key: 0,
  style: {"padding-left":"10px"}
}
const _hoisted_3 = {
  key: 0,
  class: "file-list"
}
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_download_outlined = _resolveComponent("download-outlined")!
  const _component_delete_outlined = _resolveComponent("delete-outlined")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, {
      showUploadList: false,
      name: "file",
      action: _ctx.url,
      maxCount: _ctx.maxCount,
      multiple: _ctx.multiple,
      headers: _ctx.headers,
      accept: _ctx.accept,
      onChange: _ctx.handleChange,
      beforeUpload: _ctx.beforeUpload
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, null, {
          default: _withCtx(() => [
            _createVNode(_component_upload_outlined),
            _hoisted_1
          ]),
          _: 1
        }),
        (_ctx.tipText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tipText), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["action", "maxCount", "multiple", "headers", "accept", "onChange", "beforeUpload"]),
    (_ctx.fileList.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "file-list-item",
              key: index
            }, [
              _createElementVNode("a", {
                class: "file-list-item-name",
                href: item.file_path,
                target: "_blank",
                title: item.file_name
              }, _toDisplayString(item.file_name), 9, _hoisted_4),
              _createElementVNode("a", {
                class: "file-list-item-download",
                href: item.file_path,
                target: "_blank"
              }, [
                _createVNode(_component_download_outlined)
              ], 8, _hoisted_5),
              _createVNode(_component_delete_outlined, {
                class: "file-list-item-del",
                onClick: _withModifiers(($event: any) => (_ctx.del(index)), ["stop"])
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}